// -- [Shared content card; emphasized = left accent + optional badge]

import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  emphasised?: boolean
  badge?: ReactNode
  className?: string
  /** -- Optional stagger index for motion-enter delay (0–5) */
  enterDelay?: number
  /** -- Optional data attribute for analytics / debugging */
  'data-role-tags'?: string
}

export function Card({
  children,
  emphasised = false,
  badge,
  className = '',
  enterDelay,
  'data-role-tags': dataRoleTags,
}: CardProps) {
  const delayClass =
    enterDelay != null && enterDelay >= 0 && enterDelay <= 5
      ? `motion-enter motion-enter-delay-${enterDelay}`
      : ''

  return (
    <div
      data-role-tags={dataRoleTags}
      className={`relative rounded-xl border border-line bg-white p-6 shadow-sm transition-all ${
        emphasised
          ? 'border-l-4 border-l-brand-orange shadow-md ring-1 ring-brand-orange/25'
          : ''
      } ${delayClass} ${className}`}
    >
      {badge != null && (
        <div className="absolute -top-2.5 right-3">{badge}</div>
      )}
      {children}
    </div>
  )
}

export function ForYouBadge() {
  return (
    <span className="inline-flex items-center rounded-full bg-brand-orange px-2.5 py-0.5 text-xs font-semibold text-white shadow-sm">
      For you
    </span>
  )
}
